import type { ApiHook } from 'utils/request/useApi';
import type { Extension } from '../../ExtensionsModel';

export type ListExtensionsResponse = {
  extensions: readonly Extension[];
};

export function getExtensions(api: ApiHook) {
  return api.request<ListExtensionsResponse>({
    url: 'extensions',
    method: 'GET',
  });
}
